import classNames from "classnames";
import style from "./FAQLink.module.scss";

const FAQLink = () => {
  return (
    <a className={style.faqLink} href="https://tg.org.au/faq">
      <div className={classNames("size-16", style.faqSection)}>
        <div className={classNames("size-18 bold", style.header)}>FAQs</div>
        <div className={style.descriptionLine}>
          <div>Find answers to frequently asked questions about Therapeutic Guidelines</div>
          <i className="tg-icons-LeftArrow"></i>
        </div>
      </div >
    </a>
  );
}

export default FAQLink;